import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  CircularProgress,
  Typography,
} from "@mui/material";
import { forwardRef, ReactNode } from "react";
import { Box } from "../Box";

export interface ButtonProps extends MuiButtonProps {
  isLoading?: boolean;
  helperText?: string | ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { isLoading, children, helperText, ...rest } = props;
    return (
      <Box
        display="flex"
        flexDirection="column"
        gap={1}
        fullWidth={props.fullWidth}
      >
        <MuiButton
          variant="contained"
          size="medium"
          disableRipple
          {...rest}
          disabled={isLoading || rest.disabled}
          ref={ref}
        >
          {isLoading ? (
            <Box display="flex" alignItems="center" gap={1}>
              <CircularProgress size={20} /> {children}
            </Box>
          ) : (
            children
          )}
        </MuiButton>
        {helperText && (
          <Typography
            variant="body2"
            color="text.secondary"
            fontSize="13px"
            fontWeight="600"
            textAlign="center"
          >
            {helperText}
          </Typography>
        )}
      </Box>
    );
  }
);

Button.displayName = "Button";
